import { SVGProps } from 'react';
const OrganizationIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
    >
        <path
            fillRule="evenodd"
            d="M9.4 3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0Zm.755 1.269a2.499 2.499 0 0 1-4.31 0C4.195 5.09 3.05 6.833 3.05 8.856c0 .219.013.434.04.646a2.5 2.5 0 0 1 2.16 3.59A4.826 4.826 0 0 0 8 13.95a4.826 4.826 0 0 0 2.75-.858 2.5 2.5 0 0 1 2.16-3.59c.027-.212.04-.427.04-.646 0-2.024-1.145-3.765-2.795-4.587Zm.336-1.059a2.5 2.5 0 1 0-4.983 0C3.407 4.184 1.95 6.35 1.95 8.856c0 .288.02.571.056.85a2.5 2.5 0 1 0 2.555 4.247A5.928 5.928 0 0 0 8 15.05a5.928 5.928 0 0 0 3.439-1.097 2.5 2.5 0 1 0 2.555-4.248c.037-.278.056-.561.056-.849 0-2.506-1.455-4.672-3.559-5.646ZM14.4 12a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0ZM3 13.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"
            clipRule="evenodd"
        />
    </svg>
);
export default OrganizationIcon;
